import { numericIdFn } from './_utils'

const routes = [

  {
    path: '/af',
    meta: { requiresAuth: true },
    component:  () => import(/* webpackChunkName: "af-layout" */ '@/views/af/_Layout.vue'),
    children: [
      {
        path: 'forside',
        name: 'af-home',
        component: () => import(/* webpackChunkName: "af-home" */ '@/views/af/Home.vue')
      },

      /* university */
      {
        path: 'brukere',
        name: 'af-user-list',
        component: () => import(/* webpackChunkName: "af-user-list" */ '@/views/af/User_List.vue')
      },
      {
        path: 'brukere/opprett',
        name: 'af-user-create',
        component: () => import(/* webpackChunkName: "af-user-create" */ '@/views/af/User_Create.vue')
      },
      {
        path: 'brukere/:id',
        name: 'af-user-edit',
        props: numericIdFn,
        component: () => import(/* webpackChunkName: "af-user-edit" */ '@/views/af/User_Edit.vue')
      },

      /* university */

      {
        path: 'studiesteder',
        name: 'af-university-list',
        component: () => import(/* webpackChunkName: "af-university-list" */ '@/views/af/University_List.vue')
      },
      {
        path: 'studiesteder/opprett',
        name: 'af-university-create',
        component: () => import(/* webpackChunkName: "af-university-create" */ '@/views/af/University_Create.vue')
      },
      {
        path: 'studiesteder/:id',
        name: 'af-university-edit',
        props: numericIdFn,
        component: () => import(/* webpackChunkName: "af-user-edit" */ '@/views/af/University_Edit.vue')
      },


      /* pharmacy */

      {
        path: 'apotek',
        name: 'af-pharmacy-list',
        component: () => import(/* webpackChunkName: "af-pharmacy-list" */ '@/views/af/Pharmacy_List.vue')
      },
      {
        path: 'apotek/opprett',
        name: 'af-pharmacy-create',
        component: () => import(/* webpackChunkName: "af-pharmacy-create" */ '@/views/af/Pharmacy_Create.vue')
      },
      {
        path: 'apotek/:id',
        name: 'af-pharmacy-edit',
        props: numericIdFn,
        component: () => import(/* webpackChunkName: "af-pharmacy-edit" */ '@/views/af/Pharmacy_Edit.vue')
      },

      /* chain */

      {
        path: 'kjeder',
        name: 'af-chain-list',
        component: () => import(/* webpackChunkName: "af-chain-list" */ '@/views/af/Chain_List.vue')
      },
      {
        path: 'kjeder/opprett',
        name: 'af-chain-create',
        component: () => import(/* webpackChunkName: "af-chain-create" */ '@/views/af/Chain_Create.vue')
      },
      {
        path: 'kjeder/:id',
        name: 'af-chain-edit',
        props: numericIdFn,
        component: () => import(/* webpackChunkName: "af-chain-edit" */ '@/views/af/Chain_Edit.vue')
      },

      /* period */

      {
        path: 'valgperioder',
        name: 'af-period-list',
        component: () => import(/* webpackChunkName: "af-period-list" */ '@/views/af/Period_List.vue')
      },
      {
        path: 'valgperioder/opprett',
        name: 'af-period-create',
        component: () => import(/* webpackChunkName: "af-period-create" */ '@/views/af/Period_Create.vue')
      },
      {
        path: 'valgperioder/:id',
        name: 'af-period',
        props: numericIdFn,
        component: () => import(/* webpackChunkName: "af-period" */ '@/views/af/Period_Edit.vue')
      },

      /* templates */

      {
        path: 'maler',
        name: 'af-template-list',
        component: () => import(/* webpackChunkName: "af-template-list" */ '@/views/af/Template_List.vue')
      },
      {
        path: 'maler/opprett',
        name: 'af-template-create',
        component: () => import(/* webpackChunkName: "af-template-create" */ '@/views/af/Template_Create.vue')
      },
      {
        path: 'maler/:id',
        name: 'af-template-edit',
        props: numericIdFn,
        component: () => import(/* webpackChunkName: "af-template-list" */ '@/views/af/Template_Edit.vue')
      },

      /* messages */

      {
        path: 'meldingslogg',
        name: 'af-message-list',
        component: () => import(/* webpackChunkName: "af-message-list" */ '@/views/af/Message_List.vue')
      },

      /* sms */

      {
        path: 'smslogg',
        name: 'af-sms-log',
        component: () => import(/* webpackChunkName: "af-sms-log" */ '@/views/af/Sms_Log.vue')
      },

    ]
  }
]

export default routes